import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MCUService } from 'src/app/services/mcu.service';
import swal from 'sweetalert2';
import { HttpHelper } from 'src/app/helper/htpp.helper';
import { SpinnerService } from 'src/app/shared/spinner-service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {
  statusCode?: number;
  message: string = 'An unexpected error occurred.';
  path?: string;

  constructor(private router: Router) {}

  ngOnInit() {
    const state = this.router.getCurrentNavigation()?.extras.state
                  || history.state;

    if (state) {
      this.statusCode = state['statusCode'];
      this.message = state['message'] || this.message;
      this.path = state['path'];
    }
  }

  goHome() {
    this.router.navigate(['/home']);
  }
}